import Typography from "@insite/mobius/Typography";
import StyleguideCheckboxes from "@toolkit/Library/Components/Styleguide/components/Forms/StyleguideCheckboxes";
import StyleguideDatePickers from "@toolkit/Library/Components/Styleguide/components/Forms/StyleguideDatePickers";
import StyleguideDropdowns from "@toolkit/Library/Components/Styleguide/components/Forms/StyleguideDropdowns";
import StyleguideDynamicDropdowns from "@toolkit/Library/Components/Styleguide/components/Forms/StyleguideDynamicDropdowns";
import StyleguideFileUploads from "@toolkit/Library/Components/Styleguide/components/Forms/StyleguideFileUploads";
import StyleguideRadios from "@toolkit/Library/Components/Styleguide/components/Forms/StyleguideRadios";
import StyleguideTextAreas from "@toolkit/Library/Components/Styleguide/components/Forms/StyleguideTextAreas";
import StyleguideTextFields from "@toolkit/Library/Components/Styleguide/components/Forms/StyleguideTextFields";
import StyleguideAccordions from "@toolkit/Library/Components/Styleguide/components/StyleguideAccordions";
import StyleguideBreadcrumbs from "@toolkit/Library/Components/Styleguide/components/StyleguideBreadcrumbs";
import StyleguideButtons from "@toolkit/Library/Components/Styleguide/components/StyleguideButtons";
import StyleguideDataTables from "@toolkit/Library/Components/Styleguide/components/StyleguideDataTables";
import StyleguideInfosBox from "@toolkit/Library/Components/Styleguide/components/StyleguideInfosBox";
import StyleguideModals from "@toolkit/Library/Components/Styleguide/components/StyleguideModals";
import StyleguideOverflowMenus from "@toolkit/Library/Components/Styleguide/components/StyleguideOverflowMenus";
import StyleguidePaginations from "@toolkit/Library/Components/Styleguide/components/StyleguidePaginations";
import StyleguideTabs from "@toolkit/Library/Components/Styleguide/components/StyleguideTabs";
import StyleguideTags from "@toolkit/Library/Components/Styleguide/components/StyleguideTags";
import StyleguideToasts from "@toolkit/Library/Components/Styleguide/components/StyleguideToasts";
import StyleguideTooltips from "@toolkit/Library/Components/Styleguide/components/StyleguideTooltips";
import StyleguideTypographies from "@toolkit/Library/Components/Styleguide/components/StyleguideTypographies";
import React, { FC } from "react";

const Styleguide: FC = () => {
    return (
        <>
            <Typography variant="h1">Styleguide</Typography>
            <StyleguideOverflowMenus />
            <StyleguideButtons />
            <StyleguideTextFields />
            <StyleguideTextAreas />
            <StyleguideDropdowns />
            <StyleguideDynamicDropdowns />
            <StyleguideFileUploads />
            <StyleguideDatePickers />
            <StyleguideCheckboxes />
            <StyleguideRadios />
            <StyleguideAccordions />
            <StyleguideDataTables />
            <StyleguideTypographies />
            <StyleguideTags />
            <StyleguideBreadcrumbs />
            <StyleguideModals />
            <StyleguideToasts />
            <StyleguideTabs />
            <StyleguideInfosBox />
            <StyleguideTooltips />
            <StyleguidePaginations />
        </>
    );
};

export default Styleguide;
